import { ChangeDetectorRef, Component, effect, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioButtonComponent } from '@sml/radio-button';
import { IconsComponent } from '@sml/icons';
import { Form, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppFormService, CommunitySignalService, IFormOverviewModel, ParticipantFormTypeEnum, ViewParticipateService,TooltipDirective } from '@sml/utility';
import { POST_PARTICIPATION_SUBHEADINGS } from './item-participation.constants';
import { SearchDropdownComponent } from '@sml/dropdown';
import { ToggleRadioButtonComponent } from '@sml/toggle-radio-button';

@Component({
  selector: 'sml-item-participation',
  imports: [CommonModule,RadioButtonComponent,IconsComponent,ReactiveFormsModule,SearchDropdownComponent,ToggleRadioButtonComponent,TooltipDirective],
  templateUrl: './item-participation.component.html',
  styleUrl: './item-participation.component.scss',
})
export class ItemParticipationComponent implements OnInit {
  @Input() customForms: { label: string; value: number }[] = [];
  formTypes = ParticipantFormTypeEnum
  formSubheadings=POST_PARTICIPATION_SUBHEADINGS
  showCustomFormDropdown = false;
  communityId: number | undefined;
  @Input() participationForm!: FormGroup;
  @Input() isFromCommunityStories=false
  @Input() formOverviewModel!: IFormOverviewModel | undefined;
  @Input() isVolunteer = false;
  participationType =ParticipantFormTypeEnum
  iconNameVisiblity = [
    { name: 'document' },
    { name: 'document-pen' },
  ];

  
  constructor(private communitySignalService: CommunitySignalService, private appFormService: AppFormService,private participateService:ViewParticipateService) {
  
    effect(() => {
      const community = this.communitySignalService.getCommunity();
    this.communityId = community?.id;
   
    });
  }

  

  onControlTouched() {
    this.participationForm.get('customFormType')?.markAsTouched();
    this.participationForm.get('customFormType')?.updateValueAndValidity();
  }
  onControlDirty() {
    this.participationForm.get('customFormType')?.markAsDirty();
    this.participationForm.get('customFormType')?.updateValueAndValidity();
  }

  ngOnInit(): void {
   const value =  this.participationForm.get('formType')?.value
   if(value===this.participationType['Custom Form']){
    this.showCustomFormDropdown=true;
   }
    this.participationForm.get('formType')?.valueChanges.subscribe((value) => {
      if(value==this.formTypes['Custom Form']){
        this.showCustomFormDropdown = true;
        this.participationForm.get('customFormType')?.setValidators([Validators.required]);
        this.participationForm.get('customFormType')?.updateValueAndValidity();
    }
    else{
      this.showCustomFormDropdown = false;
      this.participationForm.get('customFormType')?.clearValidators();
      this.participationForm.get('customFormType')?.updateValueAndValidity();

    }
  });

  }
  previewForm(){
    this.participateService.showParticipate({
     schema: this.formOverviewModel?.schema ?? '',
     title: this.formOverviewModel?.title ?? '',
     description: this.formOverviewModel?.description ?? '',
     isVolunteer: this.isVolunteer,
     isCalledFromItemDrawer:true
    });
  }

get control() {
    return this.participationForm.controls;
}
openSupport(){
  window.open('https://share.hsforms.com/1tm8wUMVFRfik8r0dAG-OLwqtklc ', '_blank');
}
}
